import AppDispatcher from '../core/AppDispatcher.jsx';
import Formatter from '../utils/Formatter';
import ApplicationConstants from '../constants/ApplicationConstants';
import { EventEmitter } from 'events';

const CHANGE_EVENT = 'change';
const ApplicationActionTypes = ApplicationConstants.ActionTypes;
const AccountTypes = ApplicationConstants.AccountTypeCodes;
let _formModel = {}, _product = {}, _accountType, _accountNumber;

class AnnuitiesWelcomePageStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getData() {
        let yd = _formModel.form.yourDetails, name;
        let productLabel = _product.label;
        switch(_accountType){
            case AccountTypes.INDIVIDUAL:
                name = Formatter.formatFullname(undefined, yd.givenName, yd.lastName);
                break;
            case AccountTypes.JOINT:
                yd = yd.investorList[0];
                name = Formatter.formatFullname(undefined, yd.givenName, yd.lastName);
                break;
            default:
                name = yd.businessName;
                break;
        }
        return {name: name, accountNumber: _accountNumber, productName: productLabel};
    }
}

const AnnuitiesWelcomePageStore = new AnnuitiesWelcomePageStoreClass();

AnnuitiesWelcomePageStore.dispatchToken = AppDispatcher.register((action) => {
    switch (action.actionType) {
        case ApplicationActionTypes.REVIEW_APPLICATION:
            _formModel = action.formModel;
            _product = action.product;
            _accountType = _formModel.form.accountType;
            break;
        case ApplicationActionTypes.APPLICATION_SUBMIT_SUCCESS:
            _accountNumber = action.data.accountNumber
            break;
        default:
            return true;
    }

    AnnuitiesWelcomePageStore.emitChange();
    return true;
});

export default AnnuitiesWelcomePageStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AnnuitiesWelcomePageStore.js